import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { usePunditUserContext } from "@circle-react/contexts";
import { liveStreamPaths } from "@circle-react/helpers/urlHelpers";

export const useCommunityMemberRedirect = () => {
  const { roomSlug } = useParams<{ roomSlug: string }>();
  const { currentCommunityMember, isLoading } = usePunditUserContext();
  const history = useHistory();

  useEffect(() => {
    if (!isLoading && currentCommunityMember) {
      // Redirect to standard room path
      history.push(liveStreamPaths.room({ roomSlug }));
    }
  }, [currentCommunityMember, history, isLoading, roomSlug]);
};
